<div class="card-grid" [style.width]="containerWidth">
  <div *ngFor="let item of items; trackBy: identify" class="card-grid__item" [routerLink]="[item.route]">
    <div class="card-grid__header">
      <mat-icon [ngClass]="['nav-icon', item.className]">{{ item.icon }}</mat-icon>
      <span class="card-grid__title">{{ item.text }}</span>
    </div>

    <div class="card-grid__content">
      <p>{{ item.description }}</p>
    </div>
  </div>
</div>
